// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listing-card-component {
  font-family: "Proxima Nova", sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 16px;
  padding: 20px;
  border-radius: 16px;
  background: #FFF;
  box-shadow: 0px 5px 20px 0px #EBEBEB;
}
.listing-card-component .header {
  display: flex;
  justify-content: space-between;
}
.listing-card-component .header .time {
  display: flex;
  align-items: center;
  margin: 0;
  font-size: 10px;
  font-weight: 700;
  color: var(--secondary-color-1);
  text-transform: capitalize;
}
.listing-card-component .header .time > svg {
  margin-right: 2px;
}
.listing-card-component img {
  width: 100%;
  border-radius: 8px;
  height: 140px;
  object-fit: cover;
}
.listing-card-component .price {
  font-size: 16px;
  font-weight: 700;
  margin: 0;
}
.listing-card-component .content {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}
.listing-card-component .content p {
  margin: 0;
}
.listing-card-component .content .id {
  color: #5F5F5F;
  font-size: 12px;
  line-height: 8px;
  font-weight: 700;
}
.listing-card-component .content .name {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.listing-card-component .content .address {
  line-height: 18px;
  color: #949494;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.listing-card-component .content .amenities {
  font-size: 12px;
  font-weight: 500;
  color: #5F5F5F;
  line-height: 18px;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .listing-card-component {
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ListingCard/listingCard.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,uCAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,oCAAA;AADJ;AAEI;EACI,aAAA;EACA,8BAAA;AAAR;AACQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,0BAAA;AACZ;AAAY;EACI,iBAAA;AAEhB;AAEI;EACI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AAAR;AAEI;EACI,eAAA;EACA,gBAAA;EACA,SAAA;AAAR;AAEI;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAAR;AACQ;EACI,SAAA;AACZ;AACQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AACZ;AACQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACZ;AACQ;EACI,iBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACZ;AACQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AACZ;;ACtEY;ED2ER;IACI,eAAA;EADN;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.listing-card-component {\n    font-family: 'Proxima Nova', sans-serif;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    row-gap: 16px;\n    padding: 20px;\n    border-radius: 16px;\n    background: #FFF;\n    box-shadow: 0px 5px 20px 0px #EBEBEB;\n    .header {\n        display: flex;\n        justify-content: space-between;\n        .time {\n            display: flex;\n            align-items: center;\n            margin: 0;\n            font-size: 10px;\n            font-weight: 700;\n            color: var(--secondary-color-1);\n            text-transform: capitalize;\n            > svg {\n                margin-right: 2px;\n            }\n        }\n    }\n    img {\n        width: 100%;\n        border-radius: 8px;\n        height: 140px;\n        object-fit: cover;\n    }\n    .price {\n        font-size: 16px;\n        font-weight: 700;\n        margin: 0;\n    }\n    .content {\n        display: flex;\n        flex-direction: column;\n        row-gap: 5px;\n        p {\n            margin: 0;\n        }\n        .id {\n            color: #5F5F5F;\n            font-size: 12px;\n            line-height: 8px;\n            font-weight: 700;\n        }\n        .name {\n            font-size: 14px;\n            font-weight: 600;\n            line-height: 20px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n        .address {\n            line-height: 18px;\n            color: #949494;\n            font-size: 12px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n        .amenities {\n            font-size: 12px;\n            font-weight: 500;\n            color: #5F5F5F;\n            line-height: 18px\n        }\n    }\n}\n\n@include media(mobile) {\n    .listing-card-component {\n        max-width: 100%;\n\n    }\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
